import { useState } from 'react';
import Drawer, { DrawerHeader } from 'common/components/drawer';

import { FormDrawer } from 'common/components/drawer';

import EditValuesForm from './editValuesForm';
import EditBulkValuesForm from './editBulkValuesForm';
import EditIndex from './editIndexForm';
import EditVisibilityForm from 'components/drawers/EditCompanyVisibility';

const Form = ({ drawer, active, refetchData, editMode, bulk, selected }) => {
  const [deleting, setDeleting] = useState(false);

  return active && editMode === 'visibility' ? (
    <EditVisibilityForm
      drawer={drawer}
      active={active}
      isOpen={drawer.isOpen}
      type="market-indexes"
    />
  ) : (
    <Drawer
      dontCloseOnClickOutside={deleting}
      layout="table"
      {...drawer}
      className={`edit-index ${bulk ? 'half-screen-drawer' : ''}`}
    >
      <DrawerHeader className="border-bottom pb-4">
        {active && editMode === 'values' && 'Edit Index Values'}
        {bulk && editMode === 'values' && 'Edit Index Values'}
        {active && editMode === 'editIndex' && 'Edit Index'}
        {!active && editMode === 'createIndex' && 'Create Index'}
        {active && editMode === 'visibility' && (
          <div>
            <div>Visibility Settings</div>
            <div className="fw-bold text-violet">{active.name}</div>
          </div>
        )}
      </DrawerHeader>

      <FormDrawer>
        {drawer.isOpen ? (
          <>
            {active && editMode === 'editIndex' && (
              <EditIndex
                drawer={drawer}
                active={active}
                isOpen={drawer.isOpen}
                refetchData={refetchData}
              />
            )}
            {!active && editMode === 'createIndex' && (
              <EditIndex drawer={drawer} isOpen={drawer.isOpen} refetchData={refetchData} />
            )}
            {active && editMode === 'values' && (
              <EditValuesForm
                refetchData={refetchData}
                isOpen={drawer.isOpen}
                drawer={drawer}
                active={active}
                setDeleting={value => setDeleting(value)}
              />
            )}

            {bulk && editMode === 'values' && (
              <EditBulkValuesForm
                refetchData={refetchData}
                isOpen={drawer.isOpen}
                drawer={drawer}
                selected={selected}
                setDeleting={value => setDeleting(value)}
              />
            )}
          </>
        ) : null}
      </FormDrawer>
    </Drawer>
  );
};

export default Form;
